import { Card } from "../Card";
import { GridStyled } from "./styles";

interface GridProps {
	items?: {
		image: string;
		title: string;
		description?: string;
	}[];
}

export const Grid: React.FC<GridProps> = ({ items }) => {
	return (
		<GridStyled>
			{items?.map((item, key) => (
				<Card item={item} key={key} />
			))}
		</GridStyled>
	);
};
